import { useState, useCallback } from "react";
import { useQuery, useApolloClient } from "@apollo/client";
import { ContentQuery, NextPlaylistContentQuery } from "arena/queries";

export default function useContentLoader({
  initialContentId,
  productId,
  collectionId,
}) {
  const client = useApolloClient();

  const [contents, setContents] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  // Загружаем начальный контент
  const { error } = useQuery(ContentQuery, {
    variables: { contentId: initialContentId },
    skip: contents.length > 0 || !initialContentId, // 🔴 Исправление: пропускаем если нет initialContentId
    onCompleted: (data) => {
      if (!data?.content) {
        return;
      }

      setContents([data.content]);
      loadTwoNextContent(data.content.id);
      setInitialLoading(false);
    },
  });

  // Функция загрузки следующего контента
  const loadNextContent = useCallback(
    async (fromContentId) => {
      if (loadingMore) return;

      setLoadingMore(true);

      try {
        const { data } = await client.query({
          query: NextPlaylistContentQuery,
          variables: {
            contentId: fromContentId,
            productId,
            collectionId,
            type: "SHORTY",
            contentIdsNot: contents.map((content) => content.id),
          },
        });

        if (data?.nextPlaylistContent) {
          setContents((prev) => [...prev, data.nextPlaylistContent]);
        }

        return data?.nextPlaylistContent;
      } catch (error) {
        console.error("Error loading next content:", error);
        return null; // 🔴 Исправление: возвращаем null при ошибке
      } finally {
        setLoadingMore(false);
      }
    },
    [loadingMore, client, productId, collectionId, contents]
  );

  const loadTwoNextContent = useCallback(
    async (fromContentId) => {
      const nextContent = await loadNextContent(fromContentId);
      // 🔴 Исправление: проверяем nextContent перед использованием
      if (nextContent) {
        await loadNextContent(nextContent.id);
      }
    },
    [loadNextContent]
  );

  // Callback для загрузки больше контента
  const handleLoadMore = useCallback(() => {
    if (contents.length === 0) return;

    const lastContent = contents[contents.length - 1];
    loadNextContent(lastContent.id);
  }, [contents, loadNextContent]);

  return {
    contents,
    loadingMore,
    initialLoading,
    error,
    handleLoadMore,
  };
}
